import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const MeasurementList = () => {
  const [loading, setLoading] = useState(false);
  const [schoolList, setSchoolList] = useState([]);
  const [sectionlList, setSectionList] = useState([]);
  const [totalStudents, setTotalStudents] = useState(0);
  const [measurementTaken, setMeasurementTaken] = useState(0);
  const [measurementList, setMeasurementList] = useState([]);
  const [showListModal, setShowListModal] = useState(false);
  const [schoolId, setSchoolId] = useState("");
  const [students, setStudents] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [sizeResponse, setSizeResponse] = useState(null);
  const [activeItemId, setActiveItemId] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showFilterSummary, setShowFilterSummary] = useState(false);
  const [showStudentCountField, setShowStudentCountField] = useState(false);
  const [selectedSizeByItem, setSelectedSizeByItem] = useState({});
  const [sizeList, setSizeList] = useState([]);
  const [selectedSizeId, setSelectedSizeId] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
const [schoolDetails, setSchoolDetails] = useState(null);
const [filteredClasses, setFilteredClasses] = useState([]);
  const today = new Date().toISOString().split("T")[0];

  const [editMeasurementForm, setEditMeasurementForm] = useState({
    id: "",
    custom_date: "",
    school_id: "",
    class_id: "",
    section_id: "",
    roll_no: "",
    gender_id: "",
  });

  const fetchSizeReference = async (itemId, measurements) => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        item_id: itemId,
        length: measurements.length || "",
        chest: measurements.chest || "",
        shoulder: measurements.shoulder || "",
        sleeve_length: measurements.sleeve_length || "",
        sleeve_opening: measurements.sleeve_opening || "",
        round_neck: measurements.round_neck || "",
        waist: measurements.waist || "",
        thigh: measurements.thigh || "",
        inseam: measurements.inseam || "",
        bottom: measurements.bottom || "",
        crotch: measurements.crotch || "",
        bust: measurements.bust || "",
        hip: measurements.hip || "",
        neck_depth: measurements.neck_depth || "",
        hps_to_waist: measurements.hps_to_waist || "",
        armhole: measurements.armhole || "",
      };

      const res = await axios.post(`${BASE_URL}/getSizesReference`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.status) {
        setSizeResponse(res.data);
        // setActiveItemId(itemId);
      }
    } catch (err) {
      if (handle401(err)) return;
      console.error("Size reference error", err);
    }
  };

const fetchSizes = async (itemId) => {
  try {
    const token = localStorage.getItem("token");

    const res = await fetch(
      "https://sutmmg.codydeasoftech.in/api/sizesList",
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ item_id: itemId }),
      }
    );

    const data = await res.json();

    if (data.status && Array.isArray(data.data)) {
      setSizeList(
        data.data.map((item) => ({
          id: item.id,
          size: item.size,
        }))
      );


    }
  } catch (error) {
    console.error("fetchSizes error:", error);
  }
};


  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d)) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const openEditModal = async (row) => {
    //   setMeasurementForm(row);
    setShowEditModal(true);

    setEditMeasurementForm((prev) => ({
      ...prev,
      id: row.id,
      school_id: String(row.school_id),
      class_id: String(row.class_id),
      section_id: String(row.section_id),
      roll_no: row.roll_no,
      gender_id: String(row.gender_id),
      gender_short: row.gender_short_name,
      custom_date: row.custom_date,
      shg_id: row.shg_id,
      member_id: row.member_id,
    }));

    setSectionId(String(row.section_id));

    await fetchItems(row.gender_id, row.class_id);

    setItemIds([row.item_id]);

    setItemMeasurements({
      [row.item_id]: {
        length: row.length || "",
        waist: row.waist || "",
        chest: row.chest || "",
        shoulder: row.shoulder || "",
        bust: row.bust || "",
        sleeve_length: row.sleeve_length || "",
        hip: row.hip || "",
        thigh: row.thigh || "",
        round_neck: row.round_neck || "",
        sleeve_opening: row.sleeve_opening || "",
        inseam: row.inseam || "",
        bottom: row.bottom || "",
        qty: row.quantity || 1,
        size_id: row.size_id || null,
        crotch: row.crotch || "",
        size: row.size || null,
        hps_to_waist: row.hps_to_waist || "",
        armhole: row.armhole || "",
        neck_depth: row.neck_depth || "",
      },
    });
  };

  const handleEditMeasurement = async () => {
    try {
      const itemId = Object.keys(itemMeasurements)[0];
      const itemData = itemMeasurements[itemId];

      const payload = {
        id: editMeasurementForm.id,
        custom_date: editMeasurementForm.custom_date,
        school_id: editMeasurementForm.school_id,
        class_id: editMeasurementForm.class_id,
        section_id: editMeasurementForm.section_id,
        roll_no: editMeasurementForm.roll_no,
        gender_id: editMeasurementForm.gender_id,
        item_id: Number(itemId),
        size_id: itemData.size_id,
        quantity: itemData.qty,
      };

      console.log("✅ Edit Payload", payload);

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${BASE_URL}/editMeasurement`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.status) {
        Swal.fire("Updated!", response.data.message, "success");

        const updatedSchoolId = editMeasurementForm.school_id;

        const newFilters = {
          ...filters,
          school_id: updatedSchoolId,
        };

        // 1️⃣ Update state
        setFilters(newFilters);

        // 2️⃣ Close modal
        setShowEditModal(false);

        // 3️⃣ Reset edit form
        setEditMeasurementForm({});

        // 4️⃣ Fetch using SAME newFilters object
        fetchMeasurements(1, newFilters);
      } else {
        Swal.fire("Update Failed", response.data.message, "error");
      }
    } catch (error) {
      console.error("Edit error", error);
      Swal.fire("Update Failed", "Failed to update measurement", "error");
    }
  };

  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This measurement will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");

      const payload = {
        id: row.id,
      };

      const response = await axios.post(
        `${BASE_URL}/deleteMeasurement`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire("Deleted!", response.data.message, "success");

      fetchMeasurements(page);
    } catch (error) {
      Swal.fire(
        "Alert",
        error?.response?.data?.message || "Failed to delete measurement",
        "error",
      );
    }
  };

  const [filters, setFilters] = useState({
    school_id: "",
    from_date: "",
    to_date: "",
    class_id: "",
    section_id: "",
    item_id: "",
    gender_id: "",
  });

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [classList, setClassList] = useState([]);
  const [classDropdown, setClassDropdown] = useState([]);
  const [genderList, setGenderList] = useState([]);

  const [items, setItems] = useState([]);
  const [itemIds, setItemIds] = useState([]);

    const [itemsFirst, setItemsFirst] = useState([]);


  const [studentCount, setStudentCount] = useState(null);
  const [studentCountMsg, setStudentCountMsg] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [sections, setSections] = useState([]);
  const [itemMeasurements, setItemMeasurements] = useState({});
  const selectedItems = items.filter((i) => itemIds.includes(i.item_id));
  const selectedItemsEdit = items.filter((i) => itemIds.includes(i.item_id));
  const [allowMeasurement, setAllowMeasurement] = useState(false);
  const [overviewSchoolId, setOverviewSchoolId] = useState("");
  const [overviewData, setOverviewData] = useState({
    summary: {},
    boys_items: [],
    girls_items: [],
  });

  const fetchStudentMeasurementList = async (id) => {
    setLoading(true);
    setStudents([]);

    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `https://sutmmg.codydeasoftech.in/api/student-measurement-list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            school_id: id,
            page: 1,
            per_page: 10,
          },
        },
      );

      if (res.data.status) {
        const schools = res.data.data.schools;

        const studentList = Object.values(schools).flat();

        setStudents(studentList);
      }
    } catch (err) {
      console.error("Student list error", err);
      if (handle401(err)) return;
    } finally {
      setLoading(false);
    }
  };



  const extractTime = (str) => {
  if (!str) return "";
  return str.split(" - ")[1] || "";
};

  const [showModal, setShowModal] = useState(false);
  const [shgList, setShgList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [pendingStudents, setPendingStudents] = useState(null);
  const [showPendingBox, setShowPendingBox] = useState(false);

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    borderTopLeftRadius: "10px",
    backgroundColor: "#edf7fe",
    height: "10px",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

  const [measurementForm, setMeasurementForm] = useState({
    custom_date: today,
    school_id: "",
    shg_id: "",
    member_id: "",
    section_id: "",
    class_id: "",
    roll_no: "",
    gender: "",
    shoulder: "",
    chest: "",
    shirt_length: "",
    pant_waist: "",
    pant_length: "",
    gender_id: "",
    gender_short: "",
  });

  const pairQtyMap = {
    1: 2,
    2: 1,
    3: 4,
    4: 3,
    5: 6,
    6: 5,
    7: 10,
    10: 7
  };

  const handleQtyChange = (itemId, value) => {
    updateItemMeasurement(itemId, { qty: value });

    if (value === 2 && pairQtyMap[itemId]) {
      const pairId = pairQtyMap[itemId];

      // auto uncheck pair
      setItemIds((prev) => prev.filter((id) => id !== pairId));
    }
  };



  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const municipality_id = localStorage.getItem("muniId");



  const ITEM_FIELD_MAP = {
  1: [  // Boys Half Shirt
    { key: "length", label: "Length (inch)" },
    { key: "chest", label: "Chest (+4 inch ease) (inch)" },
    { key: "shoulder", label: "Across Shoulder (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "sleeve_opening", label: "Sleeve Opening (inch)" },
    { key: "round_neck", label: "Round Neck (Collar) (inch)" },
  ],
  2: [  // Boys Full Shirt
    { key: "length", label: "Length (inch)" },
    { key: "chest", label: "Chest (with ease) (inch)" },
    { key: "shoulder", label: "Across Shoulder (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "round_neck", label: "Round Neck (Collar) (inch)" },
  ],
  3: [  // Boys Half Pant
    { key: "length", label: "Length (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "thigh", label: "Thigh (inch)" },
    { key: "inseam", label: "Inseam (inch)" },
    { key: "bottom", label: "Bottom Opening (inch)" },
    { key: "crotch", label: "Crotch (inch)" },
  ],
  4: [  // Boys Full Pant
    { key: "length", label: "Length (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "thigh", label: "Thigh (inch)" },
    { key: "inseam", label: "Inseam (inch)" },
    { key: "bottom", label: "Bottom Opening (inch)" },
    { key: "crotch", label: "Crotch (inch)" },
  ],
  5: [  // Girls Half Shirt
    { key: "length", label: "Length (inch)" },
    { key: "bust", label: "Bust (with ease) (inch)" },
    { key: "shoulder", label: "Across Shoulder (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "sleeve_opening", label: "Sleeve Opening (inch)" },
    { key: "round_neck", label: "Round Neck (Collar) (inch)" },
  ],
  6: [  // Girls Full Shirt
    { key: "length", label: "Length (inch)" },
    { key: "bust", label: "Bust (with ease) (inch)" },
    { key: "shoulder", label: "Across Shoulder (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "round_neck", label: "Round Neck (Collar) (inch)" },
  ],
  10: [  // Girls Skirt
    { key: "length", label: "Length (inch)" },
    { key: "waist", label: "Waist (inch)" },
  ],
  8: [  // Girls Salwar
    { key: "length", label: "Length (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "bottom", label: "Bottom Hem (inch)" },
    { key: "crotch", label: "Crotch Level (inch)" },
    { key: "thigh", label: "Thigh with ease (inch)" },
  ],
  9: [  // Girls Kameez
    { key: "length", label: "Length (inch)" },
    { key: "bust", label: "Bust with ease (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "shoulder", label: "Shoulder (inch)" },
    { key: "hip", label: "Hip with ease (inch)" },
    { key: "bottom", label: "Bottom Hem (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "sleeve_opening", label: "Sleeve Opening (inch)" },
    { key: "neck_depth", label: "Neck Depth (inch)" },
  ],
  7: [  // Girls Tunic
    { key: "length", label: "Length (inch)" },
    { key: "hps_to_waist", label: "HSP to Waist (inch)" },
    { key: "bust", label: "Bust (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "armhole", label: "Armhole (inch)" },
  ],

  11: [  // Girls Salwar
    { key: "length", label: "Length (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "bottom", label: "Bottom Hem (inch)" },
    { key: "crotch", label: "Crotch Level (inch)" },
    { key: "thigh", label: "Thigh with ease (inch)" },
  ],
  12: [  // Girls Kameez
    { key: "length", label: "Length (inch)" },
    { key: "bust", label: "Bust with ease (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "shoulder", label: "Shoulder (inch)" },
    { key: "hip", label: "Hip with ease (inch)" },
    { key: "bottom", label: "Bottom Hem (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "sleeve_opening", label: "Sleeve Opening (inch)" },
    { key: "neck_depth", label: "Neck Depth (inch)" },
  ],
  14: [  // Boys Kurta
    { key: "length", label: "Length (inch)" },
    { key: "chest", label: "Chest (inch)" },
    { key: "shoulder", label: "Shoulder (inch)" },
    { key: "sleeve_length", label: "Sleeve Length (inch)" },
    { key: "sleeve_opening", label: "Sleeve Opening (inch)" },
    { key: "round_neck", label: "Neck (inch)" },
  ],
  15: [  // Boys Pyjama
    { key: "length", label: "Length (inch)" },
    { key: "waist", label: "Waist (inch)" },
    { key: "bottom", label: "Bottom Hem (inch)" },
    { key: "crotch", label: "Crotch Level (inch)" },
    { key: "thigh", label: "Thigh with ease (inch)" },
  ],
  13: [  // Girls Dupatta - no measurements needed
  ],
};

  const fetchSchoolDropdown = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/schoolList`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setSchoolList(res.data?.data || []);
    } catch (error) {
      if (handle401(error)) return;
      Swal.fire("Alert", "Failed to load schools", "error");
    }
  };

//   const fetchItems = async () => {
//       try {
//         const token = localStorage.getItem("token");

//         const res = await axios.post(
//           `${BASE_URL}/itemsList`,
//           {},
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           },
//         );

//         const filteredItems =
//           res.data?.data?.itemsList?.filter(
//             (item) => Number(item.status) !== 0,
//           ) || [];

//         setItems(filteredItems);
//       } catch (error) {
//         if (handle401(error)) return;
//         console.error("Fetch items error", error);
//       }
//   };

const fetchItems = async (gender_id, class_id) => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/classGenderWiseItemQuantity`,
      {
        gender_id: gender_id || "",
        class_id: class_id || "",
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data?.status) {
      setItems(res.data.data || []);
    }
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Error",
      error?.response?.data?.message || "Failed to load items",
      "error"
    );
  }
};


  const fetchOverviewOrder = async (schoolId) => {
    try {
      const res = await axios.post(
        `${BASE_URL}api/overview-order`,
        { school_id: schoolId },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.data?.status && res.data?.data) {
        setOverviewData(res.data.data);
      } else {
        // ✅ RESET when no data
        setOverviewData({
          summary: {
            total_students: 0,
            boys_count: 0,
            girls_count: 0,
          },
          boys_items: [],
          girls_items: [],
        });
      }
    } catch (error) {
      setOverviewData({
        summary: {
          total_students: 0,
          boys_count: 0,
          girls_count: 0,
        },
        boys_items: [],
        girls_items: [],
      });

      if (handle401(error)) return;

      Swal.fire(
        "Alert",
        error?.response?.data?.message || "Failed to fetch overview",
        "error",
      );
    }
  };


  const fetchItemsForFirstTime = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.post(
          `${BASE_URL}/itemsList`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const filteredItems =
          res.data?.data?.itemsList?.filter(
            (item) => Number(item.status) !== 0,
          ) || [];

        setItemsFirst(filteredItems);
      } catch (error) {
        if (handle401(error)) return;
        console.error("Fetch items error", error);
      }
    };

  const fetchgenderList = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://sutmmg.codydeasoftech.in/api/genderList`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setGenderList(response.data.data.genderList);
    } catch (err) {
      if (handle401(err)) return;
    }
  };

  const fetchStudentCount = async (schoolId, classId) => {
    try {
      if (!schoolId || !classId) {
        return;
      }
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/studentsCount`,
        {
          school_id: schoolId,
          class_id: classId,
          //   section_id: 4,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log("STUDENT COUNT RESPONSE 👉", res.data.data);
      const studentsCount = Number(res.data.data?.studentsCount || 0);
      const pendingCount = Number(res.data.data?.pendingCount || 0);

      setPendingStudents(pendingCount);
      setShowPendingBox(studentsCount > 0);
      setAllowMeasurement(true);
      setStudentCount(res.data.data?.student_count || null);
      setStudentCountMsg("");
    } catch (error) {
      console.error("Student count error", error);
      if (handle401(error)) return;
    }
  };

  const fetchSchoolWiseStudentCount = async () => {
    try {
      if (!filters.school_id) return;

      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/studentsCount`,
        {
          school_id: filters.school_id,
          class_id: filters.class_id || "",
          section_id: filters.section_id || "",
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log("STUDENT COUNT RESPONSE 👉", res.data?.data);

      const studentsCount = Number(res.data?.data?.studentsCount || 0);
      const takenCount = Number(res.data?.data?.takenCount || 0);

      // ✅ store for top display
      setTotalStudents(studentsCount);
      setMeasurementTaken(takenCount);
    } catch (error) {
      console.error("Student count error", error);
      if (handle401(error)) return;
    }
  };

  const fetchSectionList = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${BASE_URL}/sectionList`,

        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.data.status === true) {
        setSectionList(response.data.data.sectionList || []);
      } else {
        console.log("error sectionlist");
      }
    } catch (err) {
      console.error("Student count error", err);
      if (handle401(err)) return;
    }
  };

  const checkDuplicateMeasurement = async (itemId) => {
    try {
      const token = localStorage.getItem("token");

      // Find the item by item_id (not id)
      const item = items.find((i) => i.item_id === itemId);

      const payload = {
        school_id: measurementForm.school_id,
        class_id: measurementForm.class_id,
        section_id: measurementForm.section_id,
        roll_no: measurementForm.roll_no,
        item_id: item?.item_id, // now guaranteed correct
      };

      const res = await axios.post(
        `${BASE_URL}/studentsMesurementDuplicateChecking`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // Returns true if measurement is already taken
      return res.data?.data?.measurement_taken === "1";
    } catch (error) {
      if (handle401(error)) return true;
      console.error("Duplicate check failed", error);
      return true; // default to true to prevent duplicate
    }
  };


  const handleItemCheckboxClick = async (itemId) => {
    console.log("Checkbox clicked:", itemId);
    console.log("Selected items:", itemIds);

    if (
      !measurementForm.school_id ||
      !measurementForm.class_id ||
      !measurementForm.roll_no
    ) {
      Swal.fire(
        "Warning",
        "Please select School, Class and enter Roll No first",
        "warning",
      );
      return;
    }

    if (!itemIds.includes(itemId)) {
      console.log("Checking duplicate measurement...");

      const alreadyTaken = await checkDuplicateMeasurement(itemId);

      console.log("Duplicate result:", alreadyTaken);

      if (alreadyTaken) {
        Swal.fire(
          "Already Taken",
          "This student's measurement has already been taken.",
          "info",
        );
        return;
      }
    }

    console.log("Toggling item:", itemId);

    handleItemToggle(itemId);
  };


  useEffect(() => {
    console.log(" student-count useEffect triggered");

    if (
      measurementForm.school_id != null &&
      measurementForm.class_id != null &&
      sectionId != null
    ) {
      console.log("Condition PASSED → calling fetchStudentCount");
      fetchStudentCount(
        measurementForm.school_id,
        measurementForm.class_id,
        "",
      );
    } else {
      console.log(" Condition FAILED → resetting count");
      setPendingStudents(null);
      setShowPendingBox(false);
      setStudentCount(null);
      setStudentCountMsg("");
    }
  }, [measurementForm.school_id, measurementForm.class_id, sectionId]);

  useEffect(() => {
    if (overviewSchoolId) {
      fetchOverviewOrder(overviewSchoolId);
    } else {
      // Reset when no school selected
      setOverviewData({
        total_students: 0,
        boys: 0,
        girls: 0,
        boys_shirt: 0,
        boys_pant: 0,
        girls_shirt: 0,
        girls_skirt: 0,
      });
    }
  }, [overviewSchoolId]);

  //   useEffect(() => {
  //     if (sections.length > 0) {
  //       const naSection = sections.find((s) => s.section_name === "NA");
  //       if (naSection) {
  //         setSectionId(naSection.id);
  //       }
  //     }
  //   }, [sections]);

  // useEffect(() => {
  //   if (sections.length > 0 && !sectionId) { // only if sectionId is empty
  //     const naSection = sections.find((s) => s.section_name === "NA");
  //     if (naSection) {
  //       setSectionId(naSection.id);
  //     }
  //   }
  // }, [sections]);

  // useEffect(() => {
  //   fetchSchoolWiseStudentCount();
  // }, [filters.school_id, filters.class_id, filters.section_id]);

  const resetMeasurementForm = () => {
    setMeasurementForm({
      custom_date: today,
      school_id: "",
      shg_id: "",
      member_id: "",
      class_id: "",
      roll_no: "",
      gender: "",
      gender_id: "",
      gender_short: "",
    });

    setSectionId("");
    setItemIds([]);
    setItemMeasurements({});
    setAllowMeasurement(false);
    setStudentCount(null);
  };

  const renderMeasurements = (row) => {
    const fields = [
      { key: "shoulder", label: "Shoulder (Inch)" },
      { key: "chest", label: "Chest (Inch)" },
      { key: "waist", label: "Waist (Inch)" },
      { key: "length", label: "Length (Inch)" },
      { key: "bust", label: "Bust (Inch)" },
      { key: "hip", label: "Hip (Inch)" },
      { key: "thigh", label: "Thigh (Inch)" },
      { key: "sleeve_length", label: "Sleeve Length (Inch)" },
      { key: "sleeve_opening", label: "Sleeve Opening (Inch)" },
      { key: "round_neck", label: "Round Neck (Inch)" },
      { key: "inseam", label: "Inseam (Inch)" },
      { key: "bottom", label: "Bottom (Inch)" },
      { key: "crotch", label: "Crotch (Inch)" },
      { key: "neck_depth", label: "Neck Depth (Inch)" },
      { key: "hps_to_waist", label: "HPS to Waist (Inch)" },
      { key: "armhole", label: "Armhole (Inch)" },
    ];

    return fields
      .filter(
        (f) =>
          row[f.key] !== null && row[f.key] !== "" && row[f.key] !== undefined,
      )
      .map((f) => (
        <div key={f.key}>
          <strong>{f.label}:</strong> {row[f.key]}
        </div>
      ));
  };

  const fetchClassList = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setClassList(res.data?.data.class_list || []);
      setClassDropdown(res.data?.data.class_list || []);
    } catch (error) {
      if (handle401(error)) return;

      Swal.fire("Error", "Failed to load class list", "error");
    }
  };


const handleSchoolChange = async (e) => {
  const schoolId = e.target.value;

  setMeasurementForm((prev) => ({
    ...prev,
    school_id: schoolId,

    class_id: "",
    section_id: "",
  }));

  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${BASE_URL}/schoolDetails/${schoolId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const schoolData = res.data?.data;

    // ✅ Step 1: filter only classes with students > 0
    const validStudents = schoolData.students_count.filter(
      (item) => Number(item.total_student_count) > 0
    );

    // ✅ Step 2: extract class_ids
    const validClassIds = validStudents.map((item) =>
      Number(item.class_id)
    );

    // ✅ Step 3: match with classList API
    const filteredClassList = classList.filter((cls) =>
      validClassIds.includes(Number(cls.id))
    );

    // ✅ Step 4: set new dropdown list
    setClassDropdown(filteredClassList);

  } catch (error) {
    if (handle401(error)) return;
    Swal.fire("Error", "Failed to load school details", "error");
  }
};

  const fetchShg = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/vendorsList`,
        {
          vendor_type_id: 3,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setShgList(res.data?.data || []);
    } catch (error) {
      if (handle401(error)) return;

      Swal.fire("Error", "Failed to load SHG list", "error");
    }
  };

  const fetchMembers = async (shgId) => {
    try {
      if (!shgId) {
        setMemberList([]);
        return;
      }

      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/memberList`,
        {
          shg_id: shgId, // ✅ THIS WAS MISSING
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setMemberList(res.data?.data || []);
    } catch (error) {
      if (handle401(error)) return;

      console.error("Member fetch error", error);
      setMemberList([]);
    }
  };





  const fetchMeasurements = async (
    pageNo = 1,
    filterOverride = filters,
    perPageOverride = perPage,
  ) => {
    if (!filterOverride.school_id) {
      Swal.fire("Warning", "Please select school first", "warning");
      return;
    }
    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/measurementsList`,
        {
          page: pageNo,
          per_page: perPageOverride,
          school_id: filterOverride.school_id,
          from_date: filterOverride.from_date,
          to_date: filterOverride.to_date,
          class_id: filterOverride.class_id,
          section_id: filterOverride.section_id,
          item_id: filterOverride.item_id,
          gender_id: filterOverride.gender_id
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setMeasurementList(res.data.data || []);
      setPage(res.data.page || 1);
      setTotalRecords(res.data.total_records || 0);
      setTotalPages(
        Math.ceil(
          (res.data.total_records || 0) /
            (res.data.per_page || perPageOverride),
        ),
      );
    } finally {
      setLoading(false);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handleItemToggle = (id) => {
    setItemIds((prev) => {
      const isRemoving = prev.includes(id);

      if (isRemoving) {
        setItemMeasurements((prevMeasurements) => {
          const copy = { ...prevMeasurements };
          delete copy[id];
          return copy;
        });
        return prev.filter((x) => x !== id);
      }

      const item = items.find((i) => i.id === id);

      const itemName = item?.item_name?.toLowerCase() || "";

      const isTwoQty =
        // itemName.includes("skirt") ||
        itemName.includes("kameez") ||
        // itemName.includes("tunic") ||
        itemName.includes("salwar") ||
        itemName.includes("kurta") ||
        itemName.includes("pyjama");

      setItemMeasurements((prev) => ({
        ...prev,
        [id]: { qty: item?.default_quantity || 1 },
      }));

      return [...prev, id];
    });
  };


//   const handleItemToggle = (id) => {
//   setItemIds((prev) => {
//     const isRemoving = prev.includes(id);

//     if (isRemoving) {
//       setItemMeasurements((prevMeasurements) => {
//         const copy = { ...prevMeasurements };
//         delete copy[id];
//         return copy;
//       });
//       return prev.filter((x) => x !== id);
//     }

//     const item = items.find((i) => i.id === id);
//     const itemName = item?.item_name?.toLowerCase() || "";

//     // 👇 Only force 2 for specific items
//     let qty = item?.default_quantity || 1;

//     if (itemName.includes("tunic")) {
//       qty = 2;
//     }

//     setItemMeasurements((prev) => ({
//       ...prev,
//       [id]: { qty },
//     }));

//     return [...prev, id];
//   });
// };





  const fetchSections = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/sectionList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        setSections(res.data.data.sectionList);
      }
    } catch (error) {
      console.error("Section list error", error);
      if (handle401(error)) return;
    }
  };

  const submitMeasurement = async (closeAfter = false) => {
    try {
      setLoading(true);

      const item_ids = [];
      const size_ids = [];
      const quantities = [];

      itemIds.forEach((id) => {
        const item = items.find((i) => i.item_id === id);
        if (!item) return;

        const data =
          itemMeasurements[item.item_id] || itemMeasurements[id] || {};

        item_ids.push(item.item_id);

        size_ids.push(item.item_id === 13 ? 0 : data.size_id ?? 0);

        quantities.push(data.qty ?? item?.default_quantity ?? 1);
      });

      const payload = {
        custom_date: measurementForm.custom_date,
        shg_id: measurementForm.shg_id,
        member_id: Number(measurementForm.member_id) || 0,
        school_id: measurementForm.school_id,
        class_id: measurementForm.class_id,
        section_id: measurementForm.section_id,
        roll_no: measurementForm.roll_no,
        gender_id: measurementForm.gender_id,
        item_ids,
        size_ids,
        quantities,
      };

      console.log("TAKE MEASUREMENT PAYLOAD 👉", payload);

      const response = await axios.post(
        `${BASE_URL}/takeMeasurement`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const backendMessage =
        response?.data?.message || "Measurement added successfully";

      await Swal.fire("Success", backendMessage, "success");

      await fetchStudentCount(
        measurementForm.school_id,
        measurementForm.class_id,
        4,
      );
      const newFilters = {
        ...filters,
        school_id: measurementForm.school_id,
      };

      setFilters(newFilters);
      await fetchMeasurements(1, newFilters);

      setMeasurementForm((prev) => ({
        ...prev,
        roll_no: "",
      }));

      setItemIds([]);
      setItemMeasurements({});

      if (closeAfter) {
        setShowModal(false);
        setMeasurementForm((prev) => ({
          ...prev,
          gender_id: "",
          gender_short: "",
        }));
      }
    } catch (error) {
      if (handle401(error)) return;
      const errorMessage =
        error?.response?.data?.message || "Failed to add measurement";

      Swal.fire("Warning", errorMessage, "warning");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showListModal && schoolId) {
      fetchStudentMeasurementList(schoolId);
    }
  }, [showListModal, schoolId]);

  useEffect(() => {
    fetchSchoolDropdown();
    fetchShg();
    fetchClassList();
    // fetchItems();
    fetchItemsForFirstTime();
    fetchSections();
    // fetchMeasurements();
    fetchgenderList();
    fetchMembers();
    fetchSectionList();
  }, []);



  useEffect(() => {
    if (!measurementForm.gender_short) {
      setItems([]);
      setItemIds([]);
      setItemMeasurements({});
      return;
    }

    fetchItems(measurementForm.gender_id, measurementForm.class_id);

    setItemIds([]);
    setItemMeasurements({});
  }, [measurementForm.gender_id, measurementForm.class_id]);

  useEffect(() => {
    setItemIds([]);
    setItemMeasurements({});
  }, [
    measurementForm.roll_no,
    measurementForm.class_id,
    measurementForm.school_id,
  ]);


   useEffect(() => {
  if (filters.item_id) {
    // 🧹 Reset selected size BEFORE API call
    setSelectedSizeId("");

    fetchSizes(filters.item_id);
  } else {
    // if All Items selected
    setSizeList([]);
    setSelectedSizeId("");
  }
}, [filters.item_id]);

  const editItemMeasurement = async () => {
    if (!editRow) return;

    try {
      setLoading(true);

      const payload = {
        gender: editRow.gender_short_name || "M",
        shoulder: editRow.shoulder || "",
        chest: editRow.chest || "",
        length: editRow.length || "",
        waist: editRow.waist || "",
        bust: editRow.bust || "",
        hip: editRow.hip || "",
        thigh: editRow.thigh || "",
      };

      await axios.post(
        `${BASE_URL}api/student-measurement/update/${editRow.mid}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      Swal.fire("Success", "Measurement updated successfully", "success");

      setShowModal(false);
      setIsEdit(false);
      setEditRow(null);
      fetchMeasurements(page);
    } catch (error) {
      Swal.fire("Error", "Update failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const updateItemMeasurement = (itemId, values) => {
    setItemMeasurements((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        ...values,
      },
    }));
  };

  const selectedSchoolName =
    schoolList?.find((s) => String(s.id) === String(filters.school_id))?.name ||
    "";

  const handleGetReference = async (item) => {
    const measurement = itemMeasurements[item.item_id];

    if (!measurement || Object.keys(measurement).length === 0) {
      Swal.fire("Warning", "Please enter measurements first", "warning");
      return;
    }

    setSizeResponse(null);

    // active item for filling fields
    setActiveItemId(item.item_id);

    // ✅ correct id for API
    await fetchSizeReference(item.item_id, measurement);

    setShowSizeModal(true);
  };

  const resetItemMeasurement = (itemId) => {
    setItemMeasurements((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId], // keep all existing values (including qty)
        length: "",
        waist: "",
        chest: "",
        shoulder: "",
        bust: "",
        sleeve_length: "",
        hip: "",
        thigh: "",
        round_neck: "",
        sleeve_opening: "",
        inseam: "",
        bottom: "",
        crotch: "",
        size_id: null,
        size: null,
        size_label: null,
        hps_to_waist: "",
        armhole: "",
        // qty remains untouched
      },
    }));
  };

  useEffect(() => {
    if (filters.school_id) {
      fetchMeasurements(1);
    }
  }, [perPage]);

  useEffect(() => {
    if (editMeasurementForm.shg_id) {
      fetchMembers(editMeasurementForm.shg_id);
    }
  }, [editMeasurementForm.shg_id]);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ====================== FILTER CARD ====================== */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-school"></i> Student Measurement
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            {/* Select School */}
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  School <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={filters.school_id}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      school_id: e.target.value,
                      class_id: "",
                      section_id: "",
                    });

                    // ✅ hide summary until Search is clicked again
                    setShowFilterSummary(false);
                  }}
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                >
                  <option value="">Select School</option>
                  {schoolList.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name} ({s.code})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Class (Optional)
                </Form.Label>
                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      class_id: e.target.value,
                    })
                  }
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                >
                  <option value="">Select Class</option>

                  {classDropdown.map((cl) => (
                    <option key={cl.id} value={cl.id}>
                      {cl.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

             <Col md={2}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Gender (Optional)</Form.Label>

    <Form.Select
      value={filters.gender_id}
      onChange={(e) =>
        setFilters({ ...filters, gender_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Select Gender</option>
      {genderList.map((g) => (
        <option key={g.id} value={g.id}>
          {g.name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Section (Optional)
                </Form.Label>
                <Form.Select
                  value={filters.section_id}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      section_id: e.target.value,
                    })
                  }
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                >
                  <option value="">Select Section</option>

                  {sectionlList.map((sec) => (
                    <option key={sec.id} value={sec.id}>
                      {sec.section_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  From Date (Optional)
                </Form.Label>

                <Form.Control
                  type="date"
                  value={filters.from_date}
                  onChange={(e) =>
                    setFilters({ ...filters, from_date: e.target.value })
                  }
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  To Date (Optional)
                </Form.Label>

                <Form.Control
                  type="date"
                  value={filters.to_date}
                  min={filters.from_date}
                  onChange={(e) =>
                    setFilters({ ...filters, to_date: e.target.value })
                  }
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Item (Optional)</Form.Label>

    <Form.Select
      value={filters.item_id}
      onChange={(e) =>
        setFilters({ ...filters, item_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">All Items</option>
      {itemsFirst.map((i) => (
        <option key={i.id} value={i.id}>
          {i.item_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>


           <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Size (Optional)</Form.Label>

    <Form.Select
      value={selectedSizeId || ""}       // 👈 keep controlled
      onChange={(e) => setSelectedSizeId(e.target.value)}
      disabled={!filters.item_id}        // disable only when item not selected
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
        background: !filters.item_id ? "#e0e0e0" : "white",
        cursor: !filters.item_id ? "not-allowed" : "pointer",
      }}
    >
      <option value="" selected>All Size</option>

      {sizeList.map((s) => (
        <option key={s.id} value={s.id}>
          {s.size}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing (Optional)
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Search Button */}
            <Col md={3} className="mt-3">
              <Button
                className="w-100 fw-semibold text-white"
                style={{ background: "#1565C1", borderRadius: "10px" }}
                onClick={() => {
                  setShowFilterSummary(true);
                  fetchMeasurements(1);
                  fetchSchoolWiseStudentCount();
                }}
              >
                Search
              </Button>
            </Col>

            <Col md={3} className="mt-3">
              <Button
                className="w-100 fw-semibold text-white"
                style={{ background: "#E53935", borderRadius: "10px" }}
                onClick={() => {
                  const clearedFilters = {
                    school_id: "",
                    from_date: "",
                    to_date: "",
                    class_id: "",
                    section_id: "",
                    gender_id: "",
                    item_id: "",
                  };

                  setFilters(clearedFilters);
                  setPage(1);
                  setPerPage(10);

                  // ✅ just clear the list
                  setMeasurementList([]);
                  setTotalRecords(0);
                  setTotalPages(1);

                  // ✅ also clear top counters
                  setStudentCount(null);
                  setPendingStudents(null);
                }}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ====================== ADD MEASUREMENT BUTTON ====================== */}
      <Row className="mb-3">
        <Col md={2}>
          <Button
            variant="success"
            className="text-white"
            onClick={() => setShowModal(true)}
          >
            + Add Measurement
          </Button>
        </Col>
      </Row>

      {/* ====================== LOADER ====================== */}
      {loading && (
        <div className="loader-wrapper">
          <div className="blue-spinner"></div>
          <p className="loading-text">Loading...</p>
        </div>
      )}

      {/* ====================== TABLE ====================== */}
      {!loading && (
        <div>
          {showFilterSummary && filters.school_id && (
            <div className="mb-3">
              <div
                className="fw-semibold mb-2 text-center fs-3"
                style={{ color: "#3e7ff6" }}
              >
                {selectedSchoolName}
              </div>

              <div className="d-flex gap-4 justify-content-center">
                <div
                  className="px-3 py-2 rounded"
                  style={{ background: "#e3f2fd", fontWeight: 600 }}
                >
                  Students : {totalStudents ?? 0}
                </div>

                <div
                  className="px-3 py-2 rounded"
                  style={{ background: "#e8f5e9", fontWeight: 600 }}
                >
                  Measurement taken : {measurementTaken ?? 0}
                </div>
              </div>
            </div>
          )}
          <Card
            className="mb-4 border-0"
            style={{
              background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
              boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
            }}
          >
            <Table hover responsive striped>
              <thead>
                <tr>
                  <th style={theadStyle}>SL</th>
                  <th style={theadStyle}>Measurement Date & Time</th>
                  <th style={theadStyle}>School</th>
                  <th style={theadStyle}>Class Details</th>
                  <th style={theadStyle}>SHG</th>
                  <th style={theadStyle}>Member</th>


                  <th style={theadStyle}>Gender</th>
                  <th style={theadStyle}>Item Name</th>
                  <th style={theadStyle}>Measurement Details</th>
                  <th style={theadStyle}>Size</th>
                  <th style={theadStyle}>Quantity</th>
                  <th style={theadStyle}>Action</th>
                </tr>
              </thead>

              <tbody>
                {measurementList.length > 0 ? (
                  measurementList.map((row, index) => (
                    <tr key={`${row.dynamic_id}-${index}`}>
                      <td className="text-center">
                        {(page - 1) * perPage + index + 1}
                      </td>
                      <td className="text-center">
                        {formatDate(row.custom_date)} <br/> {extractTime(row.formatted_created_at)}
                      </td>
                                            <td className="text-center">{row.school_name}</td>
                      <td className="text-center">
                        {row.class_name}
                        <br />
                        Section: {row.section_name || "-"} <br />
                        Roll: {row.roll_no || "-"}
                      </td>
                      <td className="text-center">{row.shg_name}</td>
                      <td className="text-center">{row.member_name}</td>
                      <td className="text-center">{row.gender_name}</td>
                      <td className="text-center">{row.item_name}</td>
                      <td className="text-center">{renderMeasurements(row)}</td>
                      <td className="text-center">{row.size}</td>
                      <td className="text-center">{row.quantity} Pc</td>

                      <td className="text-center">
                        {row.is_issued !== 1 && (
                          <>
                            {/* Edit */}
                            <Button
                              size="sm"
                              className="me-2"
                              style={{
                                background: "#1565C1",
                                border: "none",
                                padding: "6px 10px",
                                boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background = "#0D47A1")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background = "#1565C1")
                              }
                              onClick={() => openEditModal(row)}
                            >
                              <i
                                className="fa-solid fa-pencil text-white"
                                title="Edit"
                              />
                            </Button>

                            {/* Delete */}
                            {/* <Button
                              size="sm"
                              style={{
                                background:
                                  "linear-gradient(90deg, #E53935, #D32F2F)",
                                border: "none",
                                padding: "6px 10px",
                                boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background =
                                  "linear-gradient(90deg, #D32F2F, #B71C1C)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background =
                                  "linear-gradient(90deg, #E53935, #D32F2F)")
                              }
                              onClick={() => handleDelete(row)}
                            >
                              <i
                                className="fa-solid fa-trash text-white"
                                title="Delete"
                              />
                            </Button> */}
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav>
                  <ul className="pagination shadow-sm">
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => fetchMeasurements(1)}
                      >
                        «
                      </button>
                    </li>

                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => fetchMeasurements(page - 1)}
                      >
                        ‹
                      </button>
                    </li>

                    {getPageNumbers().map((p) => (
                      <li
                        key={p}
                        className={`page-item ${page === p ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => fetchMeasurements(p)}
                        >
                          {p}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${
                        page === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => fetchMeasurements(page + 1)}
                      >
                        ›
                      </button>
                    </li>

                    <li
                      className={`page-item ${
                        page === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => fetchMeasurements(totalPages)}
                      >
                        »
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </Card>
        </div>
      )}

      {/* ADD MEASUREMENT MODAL */}
      <Modal
        show={showModal}
        onHide={() => {
          resetMeasurementForm();
          setShowPendingBox(true);
          setPendingStudents(null);
          setShowModal(false);
        }}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title>Add Measurement</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* SCHOOL - SHG - MEMBER */}
          {!isEdit && (
            <>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Date <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Control
                      type="date"
                      value={measurementForm.custom_date}
                      onChange={(e) =>
                        setMeasurementForm((prev) => ({
                          ...prev,
                          custom_date: e.target.value,
                        }))
                      }
                    />
                  </Form.Group>
                </Col>


                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      SHG <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={measurementForm.shg_id}
                      onChange={(e) => {
                        const shgId = e.target.value;

                        setMeasurementForm((prev) => ({
                          ...prev,
                          shg_id: shgId,
                          member_id: "", // reset member
                        }));

                        fetchMembers(shgId); // ✅ REQUIRED
                      }}
                    >
                      <option value="">Select SHG</option>
                      {shgList.map((shg) => (
                        <option key={shg.id} value={shg.id}>
                          {shg.vendors_master_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Member <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={measurementForm.member_id}
                      onChange={(e) =>
                        setMeasurementForm({
                          ...measurementForm,
                          member_id: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Member</option>
                      {memberList.map((m) => (
                        <option key={m.user_id} value={m.user_id}>
                          {m.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      School <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={measurementForm.school_id}
                    //   onChange={(e) => {
                    //     setMeasurementForm({
                    //       ...measurementForm,
                    //       school_id: e.target.value,
                    //       shg_id: "",
                    //       member_id: "",
                    //     });
                    //   }}

                     onChange={handleSchoolChange}
                    >
                      <option value="">Select School</option>
                      {schoolList.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name} ({s.code})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* CLASS & ROLL NUMBER */}
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Class <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={measurementForm.class_id}
                      onChange={(e) =>
                        setMeasurementForm({
                          ...measurementForm,
                          class_id: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Class</option>

                      {classDropdown.map((cl) => (
                        <option key={cl.id} value={cl.id}>
                          {cl.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Gender <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={measurementForm.gender_id}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedGender = genderList.find(
                          (g) => g.id.toString() === selectedId,
                        );

                        setMeasurementForm({
                          ...measurementForm,
                          gender_id: selectedId, // for submit
                          gender_short: selectedGender?.short_name || "", // for other APIs
                        });
                      }}
                    >
                      <option value="">Select Gender</option>
                      {genderList.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Section <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={measurementForm.section_id}
                      onChange={(e) =>
                        setMeasurementForm({
                          ...measurementForm,
                          section_id: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Section</option>

                      {sectionlList.map((sec) => (
                        <option key={sec.id} value={sec.id}>
                          {sec.section_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Roll No <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder="Enter Roll Number"
                      value={measurementForm.roll_no}
                      onChange={(e) =>
                        setMeasurementForm({
                          ...measurementForm,
                          roll_no: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                {showStudentCountField && (
                  <Form.Group>
                    <Form.Label>Student Count</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter student count"
                      value={measurementForm.student_count || ""}
                      onChange={(e) =>
                        setMeasurementForm({
                          ...measurementForm,
                          student_count: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                )}
              </Row>

              {showPendingBox && (
                <div
                  className="alert alert-warning d-flex align-items-center mt-3"
                  role="alert"
                  style={{ border: "1px solid #ffeeba" }}
                >
                  <i
                    className="fa-solid fa-circle-info me-2"
                    style={{ fontSize: "16px", color: "#856404" }}
                  ></i>

                  <span className="fw-semibold text-dark">
                    Measurement pending: {pendingStudents} students
                  </span>
                </div>
              )}

              <Row className="gy-2 mb-3">
                {items
                  .filter((i) => i.id !== 13)
                  .map((i) => {
                    const isPant = [3, 4].includes(i.id);


                    // Pant 2-piece lock
                    const pantWithTwoPiece = Object.entries(
  itemMeasurements,
).find(([id, data]) => {
  const item = items.find((it) => it.id == id);
  return (
    item &&
    [3, 4].includes(item.id) && // Check if it's a pant by ID (3=Half Pant, 4=Full Pant)
    data.qty === 2
  );
});
                    const lockedPantId = pantWithTwoPiece
                      ? pantWithTwoPiece[0]
                      : null;
                    const isDisabledPant =
                      lockedPantId &&
                      isPant &&
                      i.item_id != lockedPantId &&
                      !itemIds.includes(i.item_id);

                    // Pair rule (qty = 2)

                    const disabledByPair = Object.entries(
                      itemMeasurements,
                    ).some(
                      ([id, data]) =>
                        pairQtyMap[id] === i.item_id && Number(data.qty) === 2,
                    );



                    // 7 ↔ 10 rule
                    // const disabledBySevenTen =
                    //   (itemIds.includes(7) && i.item_id === 10) ||
                    //   (itemIds.includes(10) && i.item_id === 7);

                    // 5,6,7,10 selected → disable 8,9
                    const disabledByFiveSixSevenTen =
                      (itemIds.includes(5)  ||
                        itemIds.includes(6) ||
                        itemIds.includes(7) ||
                        itemIds.includes(10)) &&
                      (i.item_id === 8 || i.item_id === 9);

                    // 8 selected → disable 5,6,7,10
                    const disabledByEight =
                      itemIds.includes(8) &&
                      (i.item_id === 5 ||
                        i.item_id === 6 ||
                        i.item_id === 7 ||
                        i.item_id === 10);

                    const disabledByNine =
  itemIds.includes(9) &&
  (i.item_id === 5 ||
    i.item_id === 6 ||
    i.item_id === 7 ||
    i.item_id === 10);

    const disabledByOneToFour =
  (itemIds.includes(1) ||
    itemIds.includes(2) ||
    itemIds.includes(3) ||
    itemIds.includes(4)) &&
  (i.item_id === 11 || i.item_id === 12);

    // 11 selected → disable 1,2,3,4
const disabledByEleven =
  itemIds.includes(11) &&
  (i.item_id === 1 ||
    i.item_id === 2 ||
    i.item_id === 3 ||
    i.item_id === 4);

// 12 selected → disable 1,2,3,4
const disabledByTwelveBasic =
  itemIds.includes(12) &&
  (i.item_id === 1 ||
    i.item_id === 2 ||
    i.item_id === 3 ||
    i.item_id === 4);


// const pairId = pairQtyMap[i.item_id];
// const isPairItem = pairId !== undefined;

// const thisItemQty = Number(itemMeasurements[i.item_id]?.qty || 1);
// const pairItemQty = pairId ? Number(itemMeasurements[pairId]?.qty || 1) : 1;

// const disabledByPair =
//   isPairItem &&
//   (
//     (itemIds.includes(i.item_id) && thisItemQty === 2) ||
//     (itemIds.includes(pairId) && pairItemQty === 2)
//   );


                    // Final disabled status
                    const isDisabled =
                      isDisabledPant ||
                      disabledByPair ||
                      disabledByFiveSixSevenTen ||
                      disabledByEight ||
                      disabledByEleven ||
                      disabledByTwelveBasic ||
                      disabledByOneToFour||
                      disabledByNine ;

                    return (
                      <Col md={3} key={i.item_id}>
                        <Form.Check
                          type="checkbox"
                          id={`item-${i.item_id}`}
                          label={i.item_name}
                          // Uncheck 8/9 if 5/6/7/10 selected
                          checked={
                            itemIds.includes(i.item_id) &&
                            !(disabledByFiveSixSevenTen || disabledByEight)
                          }
                          onChange={() => handleItemCheckboxClick(i.item_id)}
                          disabled={isDisabled}
                        />
                      </Col>
                    );
                  })}
              </Row>
            </>
          )}

          {console.log("selectedItems:", selectedItems)}
{console.log("itemIds:", itemIds)}

          {selectedItems.map((item) => {
            console.log("Rendering item:", item.id, item.item_name);
  console.log("Fields from MAP:", ITEM_FIELD_MAP[item.id]);
            const fields = ITEM_FIELD_MAP[item.id] || [];
  const data = itemMeasurements[item.item_id] || {};

            return (
              <Card key={item.id} className="mb-3 p-3 border">
                <h6 className="fw-bold">
                  {item.item_name}
                  {itemMeasurements[item.item_id]?.size_label && (
                    <span className="ms-2 text-success">
                      ( Selected Size:{" "}
                      {itemMeasurements[item.item_id].size_label} )
                    </span>
                  )}
                </h6>

                <Row className="gy-3">
                  {fields.map((f) => (
                    <Col md={3} key={f.key}>
                      <Form.Label style={{ fontSize: "14px" }}>
                        {f.label}
                      </Form.Label>
                      <Form.Control
                        value={data[f.key] || ""}
                        onChange={(e) =>
                          updateItemMeasurement(item.item_id, {
                            [f.key]: e.target.value,
                          })
                        }
                      />
                    </Col>
                  ))}

                  {/* Quantity + Actions */}
                  <Col md={6}>
                    <Form.Label className="fw-bold">Quantity</Form.Label>

                    <div className="d-flex align-items-center gap-2">
                      {/* Quantity */}

                      <Form.Control
                        type="number"
                        min={1}
                        max={2}
                        disabled={item.ask_quantity === 0}
                        value={data?.qty ?? item.default_quantity ?? ""}
                        // value={data?.qty ?? ""}
                        style={{ width: "80px" }}
                        onChange={(e) => {
                          let value = parseInt(e.target.value);

                          console.log("Typing value:", value);
                          console.log("Item ID:", item.id);
                          console.log(
                            "Current itemMeasurements:",
                            itemMeasurements,
                          );

                          if (isNaN(value)) return;

                          if (value > 2) value = 2;
                          if (value < 1) value = 1;

                          // update qty
                          updateItemMeasurement(item.item_id, { qty: value });

                          // PAIR RULE → auto uncheck pair when qty = 2
                          if (value === 2 && pairQtyMap[item.item_id]) {
                            const pairId = pairQtyMap[item.item_id];

                            setItemIds((prev) =>
                              prev.filter((id) => id !== pairId),
                            );
                          }
                        }}
                      />

                      {item.id !== 13 && (
                        <>
                          {/* Get Reference */}
                          <Button
                            size="sm"
                            variant="info"
                            className="text-white fw-bold"
                            onClick={() => handleGetReference(item)}
                          >
                            Get Reference
                          </Button>

                          {/* Reset */}
                          <Button
                            size="sm"
                            variant="danger"
                            className="text-white fw-bold"
                            onClick={() => resetItemMeasurement(item.item_id)}
                          >
                            Reset
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </Card>
            );
          })}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              resetMeasurementForm();
              setShowModal(false);
            }}
          >
            Cancel
          </Button>

          {!isEdit && (
            <>
              <Button
                variant="warning"
                disabled={loading}
                onClick={() => submitMeasurement(false)}
              >
                {loading ? "Saving..." : "Add & Continue"}
              </Button>

              <Button
                variant="success"
                className="text-white"
                disabled={loading}
                onClick={async () => {
                  await submitMeasurement(true);

                  //   const submittedSchoolId = measurementForm.school_id;

                  //   setSchoolId(submittedSchoolId);
                  //   setShowModal(false);
                  //   setShowListModal(true);

                  const submittedSchoolId = measurementForm.school_id;

                  // 1️⃣ Set filter school
                  setFilters((prev) => ({
                    ...prev,
                    school_id: submittedSchoolId,
                  }));

                  // 2️⃣ Close modal
                  setShowModal(false);

                  // 3️⃣ Reset add form (VERY IMPORTANT)
                  setMeasurementForm({
                    school_id: "",
                    class_id: "",
                    section_id: "",
                    student_id: "",
                    height: "",
                    weight: "",
                    bmi: "",
                  });
                }}
              >
                {loading ? "Saving..." : "Add & go to List"}
              </Button>
            </>
          )}

          {isEdit && (
            <>
              <Button
                variant="success"
                disabled={loading}
                className="px-4"
                onClick={editItemMeasurement}
              >
                {loading ? "Updating..." : "Update"}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* Size refrence modal */}

      <Modal
        show={showSizeModal}
        onHide={() => setShowSizeModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title style={{ fontSize: "20px" }}>
            {sizeResponse?.message}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h5 className="text-center">
            Reference Size: {sizeResponse?.data?.size?.size}
          </h5>

          <div className="d-flex justify-content-center mt-3">
            <Button
              variant="success"
              className="text-white me-3"
              onClick={() => {
                const sizeData = sizeResponse.data.size;

                setItemMeasurements((prev) => {
                  const existing = prev[activeItemId] || {};

                  return {
                    ...prev,
                    [activeItemId]: {
                      ...existing,

                      // 🔥 APPLY SIZE META
                      size_id: sizeData.id,
                      size_label: sizeData.size,

                      // 🔥 AUTO-FILL MEASUREMENTS (only if present)
                      length: sizeData.length ?? existing.length ?? "",
                      chest: sizeData.chest ?? existing.chest ?? "",
                      shoulder: sizeData.shoulder ?? existing.shoulder ?? "",
                      sleeve_length:
                        sizeData.sleeve_length ?? existing.sleeve_length ?? "",
                      sleeve_opening:
                        sizeData.sleeve_opening ??
                        existing.sleeve_opening ??
                        "",
                      round_neck:
                        sizeData.round_neck ?? existing.round_neck ?? "",
                      waist: sizeData.waist ?? existing.waist ?? "",
                      thigh: sizeData.thigh ?? existing.thigh ?? "",
                      inseam: sizeData.inseam ?? existing.inseam ?? "",
                      bottom: sizeData.bottom ?? existing.bottom ?? "",
                      crotch: sizeData.crotch ?? existing.crotch ?? "",
                      bust: sizeData.bust ?? existing.bust ?? "",
                      hip: sizeData.hip ?? existing.hip ?? "",
                      neck_depth:
                        sizeData.neck_depth ?? existing.neck_depth ?? "",
                      hps_to_waist:
                        sizeData.hps_to_waist ?? existing.hps_to_waist ?? "",
                      armhole: sizeData.armhole ?? existing.armhole ?? "",

                      qty: existing.qty || 1,
                    },
                  };
                });

                setShowSizeModal(false);
              }}
            >
              {/* Use Size {sizeResponse?.data?.size?.size} */}
              Accept Reference
            </Button>

            <Button
              variant="danger"
              className="text-white"
              onClick={() => setShowSizeModal(false)}
            >
              Reject Reference
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit modal */}
      <Modal
        show={showEditModal}
        onHide={() => {
          resetMeasurementForm();
          setShowEditModal(false);
        }}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title>Edit Measurement</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* SCHOOL - SHG - MEMBER */}
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={editMeasurementForm.custom_date || ""}
                  onChange={(e) =>
                    setMeasurementForm((prev) => ({
                      ...prev,
                      custom_date: e.target.value,
                    }))
                  }
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  School <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={editMeasurementForm.school_id || ""}
                  onChange={(e) =>
                    setEditMeasurementForm({
                      ...editMeasurementForm,
                      school_id: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value="">Select School</option>
                  {schoolList.map((s) => (
                    <option key={s.id} value={String(s.id)}>
                      {s.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  SHG <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={editMeasurementForm.shg_id || ""}
                  onChange={(e) =>
                    setEditMeasurementForm({
                      ...editMeasurementForm,
                      shg_id: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value="">Select SHG</option>
                  {shgList.map((shg) => (
                    <option key={shg.id} value={String(shg.id)}>
                      {shg.vendors_master_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Member <span className="text-danger">*</span>
                </Form.Label>

                <Form.Select
                  value={editMeasurementForm.member_id || ""}
                  disabled
                >
                  <option value="">Select Member</option>
                  {memberList.map((m) => (
                    <option key={m.user_id} value={String(m.user_id)}>
                      {m.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* CLASS, GENDER, SECTION, ROLL */}
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Class <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={editMeasurementForm.class_id || ""}
                  disabled
                >
                  <option value="">Select Class</option>
                  {classList.map((cl) => (
                    <option key={cl.id} value={String(cl.id)}>
                      {cl.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Gender <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={editMeasurementForm.gender_id || ""}
                  disabled
                >
                  <option value="">Select Gender</option>
                  {genderList.map((g) => (
                    <option key={g.id} value={String(g.id)}>
                      {g.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Section <span className="text-danger">*</span>
                </Form.Label>

                <Form.Select
                  value={editMeasurementForm.section_id || ""}
                  onChange={(e) =>
                    setEditMeasurementForm({
                      ...editMeasurementForm,
                      section_id: e.target.value,
                    })
                  }
                >
                  <option value="">Select Section</option>
                  {sectionlList.map((sec) => (
                    <option key={sec.id} value={String(sec.id)}>
                      {sec.section_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Roll No <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Enter Roll Number"
                  value={editMeasurementForm.roll_no || ""}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ITEM MEASUREMENTS */}
          {selectedItemsEdit.map((item) => {
            const fields = ITEM_FIELD_MAP[item.id] || [];
            const data = itemMeasurements[item.item_id] || {};

            console.log(itemMeasurements);
            return (
              <Card key={item.item_id} className="mb-3 p-3 border">
                <h6 className="fw-bold">
                  {item.item_name} Measurement
                  {(data?.size || data?.size?.size) && (
                    <span className="ms-2 text-success">
                      ( Selected Size: {data?.size?.size || data?.size} )
                    </span>
                  )}
                  {itemMeasurements[item.item_id]?.size_label && (
          <span className="ms-2 text-success">
            ( Selected Size: {itemMeasurements[item.item_id].size_label} )
          </span>
        )}
                </h6>
                <Row className="gy-3">
                  {fields.map((f) => (
                    <Col md={3} key={f.key}>
                      <Form.Label style={{ fontSize: "14px" }}>
                        {f.label}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={data[f.key] || ""}
                        onChange={(e) =>
                          updateItemMeasurement(item.item_id, {
                            [f.key]: e.target.value,
                          })
                        }
                      />
                    </Col>
                  ))}

                  <Col md={6}>
                    <Form.Label className="fw-bold">Quantity</Form.Label>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Control
                        type="number"
                        value={data.qty || 1}
                        disabled
                        style={{ width: "80px" }}
                      />
                      <Button
                        size="sm"
                        variant="info"
                        className="text-white fw-bold"
                        onClick={() => handleGetReference(item)}
                      >
                        Get Reference
                      </Button>
                      <Button
                        size="sm"
                        variant="danger"
                        className="text-white fw-bold"
                        onClick={() => resetItemMeasurement(item.item_id)}
                      >
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card>
            );
          })}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              resetMeasurementForm();
              setShowEditModal(false);
            }}
          >
            Cancel
          </Button>

          <Button
            variant="success"
            disabled={loading}
            className="px-4"
            onClick={handleEditMeasurement}
          >
            {loading ? "Updating..." : "Update"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MeasurementList;
